import { createPortal } from 'react-dom';
import './WelcomeBonusModal.css';

interface WelcomeBonusModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  isProcessing?: boolean;
}

export function WelcomeBonusModal({ isOpen, onConfirm, isProcessing = false }: WelcomeBonusModalProps) {
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className="welcome-bonus-modal__overlay" role="dialog" aria-modal="true">
      <div className="welcome-bonus-modal">
        <div className="welcome-bonus-modal__badge">NEW</div>
        <h2 className="welcome-bonus-modal__title">환영 보너스 지급 완료</h2>
        <p className="welcome-bonus-modal__description">
          DSM-TCG 길드에 합류해줘서 고마워요!<br />
          첫 가입 기념으로 <strong>50 골드</strong>를 지급했습니다.
        </p>
        <div className="welcome-bonus-modal__cta">
          <button
            type="button"
            className="welcome-bonus-modal__button"
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {isProcessing ? '확인 중...' : '전장으로 이동'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}


